// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Trazas de circuito — fondo de la sección Developer
   ============================================================
   🔑 Todo el movimiento sale de \`stroke-dashoffset\` y \`opacity\`, que **no tocan el
   layout**. Es la regla del proyecto: las animaciones que desplazan elementos ya
   provocaron barras de scroll parásitas, y aquí no se desplaza nada — cambia cómo se
   pinta una línea que sigue en su sitio.

   \`pointer-events: none\` en el SVG: es decoración y no debe robar un solo clic a las
   opciones que tiene encima. */

.CircuitTraces_svg__nmK50 {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  /* Debajo del contenido pero encima del fondo del bloque. */
  z-index: 0;
  /* Sin esto el trazo se recorta en los bordes al estirarse. */
  overflow: visible;
}

/* La pista de cobre. Apenas visible: si compitiera con el texto del menú, el efecto
   dejaría de ser ambiente y pasaría a estorbar. */
.CircuitTraces_track__Y29d1 {
  fill: none;
  stroke: var(--matrix-green, #39ff88);
  stroke-width: 0.5;
  stroke-opacity: 0.16;
  stroke-linejoin: round;
  stroke-linecap: round;
}

/*
  El pulso de corriente.

  \`stroke-dasharray\` con un guion corto (8) y un hueco enorme (400) es lo que produce
  UN solo destello recorriendo la traza en lugar de una línea punteada en movimiento.
  El \`stroke-dashoffset\` va de 400 a -8 para que el guion entre por un extremo y salga
  por el otro, sin aparecer ni desaparecer a medio camino.
*/
.CircuitTraces_pulse__I\\+0xj {
  fill: none;
  stroke: var(--matrix-green, #39ff88);
  stroke-width: 1.1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 8 400;
  /* El resplandor es lo que lo hace parecer corriente y no una raya. */
  filter: drop-shadow(0 0 2px var(--matrix-green, #39ff88));
  animation-name: CircuitTraces_trace-pulse__NX7qD;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes CircuitTraces_trace-pulse__NX7qD {
  from {
    stroke-dashoffset: 400;
  }
  to {
    stroke-dashoffset: -8;
  }
}

/* Nodos de soldadura: laten desfasados para que la placa se sienta viva sin que nada
   se mueva de sitio. */
.CircuitTraces_pad__G0QYh {
  fill: var(--matrix-green, #39ff88);
  animation: CircuitTraces_pad-blink__s-34d 2.6s ease-in-out infinite;
}

@keyframes CircuitTraces_pad-blink__s-34d {
  0%,
  100% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.55;
  }
}

/**
 * Sin animación cuando el sistema lo pide.
 *
 * Las pistas y los nodos **se quedan**: son la parte que da carácter y no se mueven.
 * Lo que se detiene es el recorrido del pulso, que se aparca a media traza para que el
 * dibujo siga leyéndose como un circuito y no como líneas sueltas.
 */
@media (prefers-reduced-motion: reduce) {
  .CircuitTraces_pulse__I\\+0xj {
    animation: none;
    stroke-dashoffset: 120;
    stroke-opacity: 0.35;
  }
  .CircuitTraces_pad__G0QYh {
    animation: none;
    opacity: 0.35;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/CircuitTraces.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;+BAS+B;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2DAA2D;EAC3D,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;kDACkD;AAClD;EACE,UAAU;EACV,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;;;;;CAOC;AACD;EACE,UAAU;EACV,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,qEAAqE;EACrE,yDAAyD;EACzD,gDAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;uBACuB;AACvB;EACE,kCAAkC;EAClC,mEAA8C;AAChD;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;;;;;EAME;AACF;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   Trazas de circuito — fondo de la sección Developer\n   ============================================================\n   🔑 Todo el movimiento sale de `stroke-dashoffset` y `opacity`, que **no tocan el\n   layout**. Es la regla del proyecto: las animaciones que desplazan elementos ya\n   provocaron barras de scroll parásitas, y aquí no se desplaza nada — cambia cómo se\n   pinta una línea que sigue en su sitio.\n\n   `pointer-events: none` en el SVG: es decoración y no debe robar un solo clic a las\n   opciones que tiene encima. */\n\n.svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  /* Debajo del contenido pero encima del fondo del bloque. */\n  z-index: 0;\n  /* Sin esto el trazo se recorta en los bordes al estirarse. */\n  overflow: visible;\n}\n\n/* La pista de cobre. Apenas visible: si compitiera con el texto del menú, el efecto\n   dejaría de ser ambiente y pasaría a estorbar. */\n.track {\n  fill: none;\n  stroke: var(--matrix-green, #39ff88);\n  stroke-width: 0.5;\n  stroke-opacity: 0.16;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n}\n\n/*\n  El pulso de corriente.\n\n  `stroke-dasharray` con un guion corto (8) y un hueco enorme (400) es lo que produce\n  UN solo destello recorriendo la traza en lugar de una línea punteada en movimiento.\n  El `stroke-dashoffset` va de 400 a -8 para que el guion entre por un extremo y salga\n  por el otro, sin aparecer ni desaparecer a medio camino.\n*/\n.pulse {\n  fill: none;\n  stroke: var(--matrix-green, #39ff88);\n  stroke-width: 1.1;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 8 400;\n  /* El resplandor es lo que lo hace parecer corriente y no una raya. */\n  filter: drop-shadow(0 0 2px var(--matrix-green, #39ff88));\n  animation-name: trace-pulse;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n@keyframes trace-pulse {\n  from {\n    stroke-dashoffset: 400;\n  }\n  to {\n    stroke-dashoffset: -8;\n  }\n}\n\n/* Nodos de soldadura: laten desfasados para que la placa se sienta viva sin que nada\n   se mueva de sitio. */\n.pad {\n  fill: var(--matrix-green, #39ff88);\n  animation: pad-blink 2.6s ease-in-out infinite;\n}\n\n@keyframes pad-blink {\n  0%,\n  100% {\n    opacity: 0.15;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n/**\n * Sin animación cuando el sistema lo pide.\n *\n * Las pistas y los nodos **se quedan**: son la parte que da carácter y no se mueven.\n * Lo que se detiene es el recorrido del pulso, que se aparca a media traza para que el\n * dibujo siga leyéndose como un circuito y no como líneas sueltas.\n */\n@media (prefers-reduced-motion: reduce) {\n  .pulse {\n    animation: none;\n    stroke-dashoffset: 120;\n    stroke-opacity: 0.35;\n  }\n  .pad {\n    animation: none;\n    opacity: 0.35;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg": `CircuitTraces_svg__nmK50`,
	"track": `CircuitTraces_track__Y29d1`,
	"pulse": `CircuitTraces_pulse__I+0xj`,
	"trace-pulse": `CircuitTraces_trace-pulse__NX7qD`,
	"pad": `CircuitTraces_pad__G0QYh`,
	"pad-blink": `CircuitTraces_pad-blink__s-34d`
};
export default ___CSS_LOADER_EXPORT___;
